import { Control, Controller } from "react-hook-form";
import { CreatableSelect } from "chakra-react-select";
import { Field } from "@/components/ui/field";

interface FundSourceControllerProps {
    control: Control<any, any>;
    name: string;
    label: string;
    readOnly: boolean;
    options: string[];
    required?: boolean;
}

const FundSourceController = ({ control, name, label, readOnly, options, required }: FundSourceControllerProps) => {
    const mandatory = required ?? false;
    const selectOptions = options.map(option => ({ label: option, value: option }));

    return (
        <Controller
            control={control}
            name={name}
            rules={{ required: mandatory && "Institution auswählen", validate: (value) => !mandatory || !!value?.trim() || "Institution auswählen" }}
            render={({ field: { value, name, onChange, onBlur, ref }, fieldState: { error, invalid } }) => (
                <Field id={name} label={label} disabled={readOnly} required={mandatory} invalid={invalid} errorText={error?.message}>
                    <CreatableSelect
                        isSearchable
                        isClearable
                        required={mandatory}
                        readOnly={readOnly}
                        ref={ref}
                        name={name}
                        autoFocus={false}
                        onBlur={onBlur}
                        placeholder="Institution"
                        options={selectOptions}
                        onChange={val => onChange(val?.value ?? "")}
                        value={selectOptions.find(c => c.value === value)}
                        formatCreateLabel={(item) => `Neue Institution Erstellen: ${item}`}
                    />
                </Field>
            )}
        />
    );
};

export default FundSourceController;
